import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "default-content" }
const _hoisted_3 = { class: "info-box" }
const _hoisted_4 = { class: "test-name" }
const _hoisted_5 = { class: "test-label" }
const _hoisted_6 = { class: "test-name" }
const _hoisted_7 = { class: "test-label" }
const _hoisted_8 = { class: "test-label" }
const _hoisted_9 = { class: "progress-box" }
const _hoisted_10 = { class: "progress" }
const _hoisted_11 = {
  key: 0,
  class: "step-container"
}
const _hoisted_12 = {
  key: 0,
  class: "participant-table"
}
const _hoisted_13 = { class: "token-col" }
const _hoisted_14 = { class: "button-bar" }

export function render(_ctx, _cache) {
  const _component_Header = _resolveComponent("Header")
  const _component_Navigation = _resolveComponent("Navigation")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_step = _resolveComponent("el-step")
  const _component_el_steps = _resolveComponent("el-steps")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_button = _resolveComponent("el-button")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header, {
      windowWidth: _ctx.windowWidth,
      windowHeight: _ctx.windowHeight
    }, null, 8, ["windowWidth", "windowHeight"]),
    _createVNode(_component_Navigation, {
      activeMenu: _ctx.NavigationIndex.TEST,
      windowWidth: _ctx.windowWidth,
      windowHeight: _ctx.windowHeight
    }, null, 8, ["activeMenu", "windowWidth", "windowHeight"]),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createVNode(_component_el_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_main, null, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createElementVNode("div", { class: "danger" }, [
                  _createElementVNode("h4", null, "Zugang verweigert."),
                  _createElementVNode("p", null, "Sie besitzen nicht die erforderliche Berechtigung für diesen Bereich.")
                ], -1)
              ])),
              _: 1
            })
          ]),
          _: 1
        }, 512), [
          [_vShow, !_ctx.hasPermission['TEST_UPDATE'] && !_ctx.loading]
        ]),
        (_ctx.testModel)
          ? (_openBlock(), _createBlock(_component_Breadcrumbs, {
              key: 0,
              breadcrumbs: [['Prüfungen', '/test'], [_ctx.testName, '/test/'+_ctx.testModel.testid], ['Durchführung']]
            }, null, 8, ["breadcrumbs"]))
          : _createCommentVNode("", true),
        _withDirectives(_createVNode(_component_el_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_main, { class: "rounded-content" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_el_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.testName), 1)
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, {
                        span: 12,
                        align: "right"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_6, [
                            _cache[1] || (_cache[1] = _createTextVNode(" am ")),
                            _createElementVNode("span", _hoisted_7, _toDisplayString(new Intl.DateTimeFormat('de-DE', {year: 'numeric', month: '2-digit', day: '2-digit'}).format(new Date(0).setUTCSeconds(_ctx.testDate))), 1),
                            _cache[2] || (_cache[2] = _createTextVNode(" um ")),
                            _createElementVNode("span", _hoisted_8, _toDisplayString(new Intl.DateTimeFormat('de-DE', {hour: '2-digit', minute: '2-digit'}).format(new Date(0).setUTCSeconds(_ctx.testDate))) + " Uhr", 1)
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_el_steps, {
                      active: _ctx.step,
                      "finish-status": "success"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_step, {
                          title: "Schritt 1",
                          description: "Vorbereitung"
                        }),
                        _createVNode(_component_el_step, {
                          title: "Schritt 2",
                          description: "Kontrolle des Fragebogens"
                        }),
                        _createVNode(_component_el_step, {
                          title: "Schritt 3",
                          description: "Feststellung der Anwesenheit"
                        }),
                        _createVNode(_component_el_step, {
                          title: "Schritt 4",
                          description: "Durchführung der Prüfung"
                        })
                      ]),
                      _: 1
                    }, 8, ["active"])
                  ])
                ]),
                (_ctx.step == 4)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _cache[3] || (_cache[3] = _createElementVNode("h3", { class: "step-header" }, "Übersicht der Prüfungsergebnisse", -1)),
                      (_ctx.step == 4 && _ctx.substep == 1 && !_ctx.loading)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _createVNode(_component_el_table, { data: _ctx.participantList }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_table_column, {
                                  label: "Teilnahme-ID",
                                  width: "200",
                                  align: "right"
                                }, {
                                  default: _withCtx((scope) => [
                                    _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.participantList[scope.$index].prefix + '-' + _ctx.participantList[scope.$index].token), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_table_column, {
                                  label: "Fragen",
                                  width: "100",
                                  align: "right"
                                }, {
                                  default: _withCtx((scope) => [
                                    _createTextVNode(_toDisplayString(_ctx.participantList[scope.$index].answercount) + " / " + _toDisplayString(_ctx.testModel.questioncount), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_table_column, {
                                  label: "Korrekt beantwortet",
                                  width: "180",
                                  align: "right"
                                }, {
                                  default: _withCtx((scope) => [
                                    _createTextVNode(_toDisplayString(_ctx.participantList[scope.$index].successpct) + "% ", 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_table_column, {
                                  label: "Ergebnis",
                                  width: "180",
                                  align: "center"
                                }, {
                                  default: _withCtx((scope) => [
                                    _createTextVNode(_toDisplayString(_ctx.participantList[scope.$index].haspassed ? 'bestanden' : 'durchgefallen'), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["data"])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_14, [
                  (_ctx.step == 4 && _ctx.substep == 1)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        type: "primary",
                        onClick: _ctx.onReturnClick
                      }, {
                        default: _withCtx(() => _cache[4] || (_cache[4] = [
                          _createTextVNode("Beenden")
                        ])),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512), [
          [_vShow, _ctx.hasPermission['TEST_UPDATE']]
        ])
      ])
    ])), [
      [_directive_loading, _ctx.loading]
    ])
  ], 64))
}